import * as actions from './actions'
import { takeLatest, call, put, select } from 'redux-saga/effects'
import axios from 'axios'
import { enqueueSnackbar, startLoading, stopLoading } from '../../../actions'
import { getSagasMsgs } from '../../../selectors'

export const watchSendMailSaga = [takeLatest(actions.MAIL_REQUEST, sendMail)]

function* sendMail(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(sendMailRequest, action.data)
        yield put(actions.sendMailReportSuccess(response))
        yield put(stopLoading())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.mailSendRes,
                options: {
                    variant: 'success'
                }
            })
        )
    } catch (ex) {
        yield put(actions.sendMailReportError())
        yield put(stopLoading())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.mailSendEx,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

async function sendMailRequest(data) {
    const formData = new FormData()

    formData.append('image1', data.image)
    formData.append('image2', data.imageZoom)
    formData.append('dataEmailAn', data.emailAn)
    formData.append('dataEmailCc', data.emailCc)
    formData.append('dataEmailMessage', data.emailMessage)
    formData.append('dataLocalization', data.localization)
    formData.append('reportDataId', data.reportData.id)
    formData.append('reportDataName', data.reportData.name)
    formData.append('reportDataCreatedAt', data.reportData.created_at)
    formData.append('reportDataLocationName', data.reportData.location_name)
    formData.append('reportDataLocationId', data.reportData.location_id)
    formData.append('reportDataCustomerId', data.reportData.customer_id)

    const response = await axios.post(
        `${process.env.API_URL}/reports/send-email/`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )

    return response.data
}
